import { Box, Skeleton } from '@mui/material';
import ButtonWrapper from '../../formUtilities/useButton';
import TextWrapper from '../../formUtilities/useTextWrapper';
import { Spacing } from './spacing';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CardSpacing } from '../../../constants/cardSpacing';
import { LabelBadge } from './labelBadge';

export default function ActionBarDetail({
	userName,
	status,
	actionButtons,
	loading = false,
	link = null,
}) {
	const style = {
		margin: '-20px -15px 0px',
		position: 'relative',
		background: 'rgba(255,255,255,.45)',
		padding: '20px',
	};

	const navigate = useNavigate();

	const getUsername = () => {
		let name = 'Details';
		if (!userName) {
			return name;
		}

		if (userName === 'null' || userName === 'undefined') {
			return name;
		}

		return userName;
	};

	return (
		<>
			<Box
				className="md:flex-row flex-col !items-start"
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					...style,
				}}>
				<Box className="flex items-center md:mb-0 mb-4 md:w-[50%] w-full">
					{!loading ? (
						<>
							<ButtonWrapper
								classList="!arrow-back-nav-btn"
								iconButton={true}
								icon={<ArrowBackIcon />}
								onClick={() => {
									navigate(-1);
								}}></ButtonWrapper>
							<TextWrapper
								classList="!mx-1 font-bold text-2xl uppercase !text-start !overflow-hidden !whitespace-nowrap !text-ellipsis"
								text={link ? <a style={{fontSize:'inherit'}} href={link}>{getUsername()}</a> : getUsername()}
								type={'span'}></TextWrapper>
							{status ? (
								<LabelBadge
									classList={'!mx-3 !whitespace-nowrap !min-w-[110px]'}
									label={status}></LabelBadge>
							) : null}
						</>
					) : (
						<>
							<Skeleton
								variant="circular"
								width={40}
								height={40}
							/>
							<Skeleton
								className="!mx-1"
								variant="text"
								sx={{ fontSize: '1.5rem', width: '200px' }}
							/>
						</>
					)}
				</Box>
				<Box className="grid gap-2 md:grid-flow-col md:grid-cols-none sm:grid-cols-1 w-full md:w-auto">
					{!loading ? (
						<>{actionButtons}</>
					) : (
						<>
							<Box className="grid grid-cols-4 gap-3 w-full">
								<Skeleton
									variant="text"
									sx={{ fontSize: '2rem', width: '100px' }}
								/>
								<Skeleton
									variant="text"
									sx={{ fontSize: '2rem', width: '100px' }}
								/>
								<Skeleton
									variant="text"
									sx={{ fontSize: '2rem', width: '100px' }}
								/>
								<Skeleton
									variant="text"
									sx={{ fontSize: '2rem', width: '100px' }}
								/>
							</Box>
						</>
					)}
				</Box>
			</Box>
			<Spacing space={CardSpacing.lg} />
		</>
	);
}
